import type { CSSProperties } from 'react';
import { CWITNESSCARD_MOBILE_STICKY_TOP } from './cwitnesscardConstants';

interface WitnessCardRootStyleInput {
  isSticky?: boolean;
  style?: CSSProperties;
}

interface WitnessCardSurfaceStyleInput {
  isAnimated: boolean;
  isSticky?: boolean;
}

export const WITNESS_CARD_MOTION_WRAPPER_STYLE = {
  width: '100%',
  height: '100%',
  display: 'flex',
  maxWidth: '840px',
} as const;

export const WITNESS_CARD_STATIC_IMAGE_WRAPPER_STYLE = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  zIndex: 0,
  overflow: 'hidden',
} as const;

export const WITNESS_CARD_ANIMATED_IMAGE_WRAPPER_STYLE = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  zIndex: 0,
} as const;

export const WITNESS_CARD_STATIC_IMAGE_STYLE = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
} as const;

export const WITNESS_CARD_ANIMATED_IMAGE_STYLE = {
  width: '100%',
  height: 'calc(100% + 40px)',
  marginTop: '-20px',
  objectFit: 'cover',
  filter: 'grayscale(100%)',
} as const;

export const WITNESS_CARD_GRADIENT_OVERLAY_STYLE = {
  position: 'absolute',
  inset: 0,
  backgroundImage: 'linear-gradient(to top, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.5) 40%, transparent 100%)',
  zIndex: 1,
  pointerEvents: 'none',
  display: 'flex',
} as const;

export const WITNESS_CARD_CONTENT_WRAPPER_STYLE = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  padding: 40,
  zIndex: 2,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  pointerEvents: 'none',
} as const;

export const WITNESS_CARD_HOVER_PROMPT_STYLE = {
  position: 'absolute',
  top: 24,
  right: 24,
  zIndex: 3,
  display: 'flex',
} as const;

export function getWitnessCardRootStyle({
  isSticky,
  style,
}: WitnessCardRootStyleInput): CSSProperties {
  return {
    display: 'flex',
    justifyContent: 'center',
    height: 500,
    flexShrink: 0,
    position: isSticky ? 'sticky' : 'relative',
    top: isSticky ? CWITNESSCARD_MOBILE_STICKY_TOP : undefined,
    ...style,
  };
}

export function getWitnessCardSurfaceStyle({
  isAnimated,
  isSticky,
}: WitnessCardSurfaceStyleInput): CSSProperties {
  return {
    position: 'relative',
    boxShadow: isAnimated
      ? '-5px 11px 30px -12px rgb(102 254 193 / 11%), 4px -7px 12px -2px rgba(255, 255, 255, 0.03)'
      : '0 12px 24px -18px rgb(102 254 193 / 28%)',
    border: '1px solid #ffffff17',
    ...(isSticky && { borderRadius: '4rem' }),
  };
}

export function getWitnessCardContentInnerStyle(
  isSticky?: boolean,
): CSSProperties {
  return isSticky ? {} : { maxWidth: '70%' };
}
